/**
 * mpTestDefaults — ARAM is the Fase 5 multiplayer harness map (P4-02).
 * No networking here; Phase 5 consumes this id for WS/lobby-room tests.
 */

export const MP_TEST_MAP_ID = 'aram_proving_grounds';

export function isMpTestMap(mapId) {
  return mapId === MP_TEST_MAP_ID;
}

/**
 * Stable lobby order: MP test bed first, then alphabetical.
 */
export function orderMapsForLobby(mapIds = []) {
  return [...mapIds].sort((a, b) => {
    if (a === MP_TEST_MAP_ID) return -1;
    if (b === MP_TEST_MAP_ID) return 1;
    return String(a).localeCompare(String(b));
  });
}
